<template>
  <Layout />
  <ReloadPrompt />
  <!-- بطاقة العرض الترويجي — تظهر في أي صفحة، مرة واحدة بالجلسة، دون إزعاج -->
  <PromoCard v-if="promo" v-model="showPromo" :promo="promo" @dismissed="dismissPromo" />
</template>

<script setup>
import { onMounted } from "vue";
import Layout from "./components/Layout.vue";
import ReloadPrompt from "./components/ReloadPrompt.vue";
import PromoCard from "./components/promo/PromoCard.vue";
import { usePromo } from "./composables/usePromo";

// Promo shows once per session wherever the user lands (login redirects
// straight to the generator, so a global mount is the only reliable place).
const { promo, showPromo, fetchPromo, dismissPromo } = usePromo();
onMounted(() => fetchPromo({ delayMs: 1200 }));
</script>

<style>
/* 
  هنا يمكنك وضع الأنماط العامة جدًا مثل إعدادات الخطوط
  التي نقلناها من Login.vue في المرة السابقة.
  تأكد من وجود استيراد الخط هنا إذا كنت تستخدمه.
*/
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;700&display=swap");

body {
  margin: 0;
  font-family: "Cairo", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7fafc; /* لون الخلفية العام */
}

/* 🔝 Force Scroll to Top button to always be on top of everything */
.q-page-scroller {
  z-index: 99999 !important;
}
.q-page-scroller .q-btn {
  z-index: 99999 !important;
}
</style>
